module.exports = __webpack_public_path__ + "static/media/TartaletaCoco.1813dca1.jpg";